<!-- src/components/Applications/UppsognSereign/Steps/Summary.vue -->
<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Substeps (use your existing files)
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import PEP from '../../Shared/PEP.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// Expand first panel by default
const expanded = ref<number[]>([0])
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('umsokn_samantekt_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Summary expansion -->
      <v-row>
          <v-expansion-panels v-model="expanded" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_upplysingar') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>
                  <Umsaekjandi :disable="true" />
                </div>

                <div class="m-t-100">
                  <Step2 :disable="true" />
                </div>

                <div class="m-t-100">
                  <Step3 :disable="true" />
                </div>

                <div class="m-t-100">
                  <Step4 :disable="true" />
                </div>

                <!-- PEP shown in summary without disclaimer -->
                <div class="m-t-100">
                  <PEP :disable="true" :showDisclamer="false" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-t-100 { margin-top: 100px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
</style>
